export function truncateString(num: number, str?: string) {
    if (str && str?.length > num) {
      return str.slice(0, num - 1) + "...";
    } else {
      return str;
    }
  }